var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Guid, Wait } from '@gower/utils';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import classNames from "classnames";
import { setupRegex, testRegex } from './Mask';
export var Input = React.forwardRef(function (_a, ref) {
    var _b, _c;
    var _d, _e;
    var label = _a.label, emitAll = _a.emitAll, hint = _a.hint, errorMessage = _a.errorMessage, onlyNumbers = _a.onlyNumbers, textLeft = _a.textLeft, textRight = _a.textRight, iconRight = _a.iconRight, iconLeft = _a.iconLeft, contentRight = _a.contentRight, contentLeft = _a.contentLeft, variant = _a.variant, color = _a.color, size = _a.size, className = _a.className, round = _a.round, rootClassname = _a.rootClassname, required = _a.required, password = _a.password, autoFocus = _a.autoFocus, selectAllOnFocus = _a.selectAllOnFocus, onClickIconLeft = _a.onClickIconLeft, onClickIconRight = _a.onClickIconRight, validator = _a.validator, onValidateError = _a.onValidateError, onFocus = _a.onFocus, onBlur = _a.onBlur, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onEnterDown = _a.onEnterDown, onEnterUp = _a.onEnterUp, onEscapeDown = _a.onEscapeDown, onEscapeUp = _a.onEscapeUp, onClear = _a.onClear, prefix = _a.prefix, suffix = _a.suffix, small = _a.small, normal = _a.normal, large = _a.large, width = _a.width, numeric = _a.numeric, filled = _a.filled, outlined = _a.outlined, solo = _a.solo, borderless = _a.borderless, clearable = _a.clearable, disabled = _a.disabled, readOnly = _a.readOnly, onChange = _a.onChange, value = _a.value, noEffect = _a.noEffect, mask = _a.mask, beforeCheckMask = _a.beforeCheckMask, contentModal = _a.contentModal, widthModal = _a.widthModal, maxHeightModal = _a.maxHeightModal, heightModal = _a.heightModal, props = __rest(_a, ["label", "emitAll", "hint", "errorMessage", "onlyNumbers", "textLeft", "textRight", "iconRight", "iconLeft", "contentRight", "contentLeft", "variant", "color", "size", "className", "round", "rootClassname", "required", "password", "autoFocus", "selectAllOnFocus", "onClickIconLeft", "onClickIconRight", "validator", "onValidateError", "onFocus", "onBlur", "onKeyDown", "onKeyUp", "onEnterDown", "onEnterUp", "onEscapeDown", "onEscapeUp", "onClear", "prefix", "suffix", "small", "normal", "large", "width", "numeric", "filled", "outlined", "solo", "borderless", "clearable", "disabled", "readOnly", "onChange", "value", "noEffect", "mask", "beforeCheckMask", "contentModal", "widthModal", "maxHeightModal", "heightModal"]);
    var rootEl = React.useRef();
    var inputEl = React.useRef();
    var formatedMaskTests = [];
    var _f = React.useState(false), isFocused = _f[0], setFocus = _f[1];
    var _g = React.useState(false), isErrored = _g[0], setErrored = _g[1];
    var _h = React.useState(false), isPasswordVisible = _h[0], setPasswordVisible = _h[1];
    var _j = React.useState(false), isClearableVisible = _j[0], setIsClearableVisible = _j[1];
    var _k = React.useState(false), optionsOpen = _k[0], setOptionsOpen = _k[1];
    var _l = React.useState(''), inputValue = _l[0], setInputValue = _l[1];
    var _m = React.useState(0), inputCharPos = _m[0], setInputCharPos = _m[1];
    var waitEmit = React.useRef(null);
    var autocompleteId = React.useState(Guid(1, true))[0];
    if (!props.autoComplete)
        props.autoComplete = "nope";
    if (!props["aria-autocomplete"])
        props["aria-autocomplete"] = "none";
    if (!props.autoCorrect)
        props.autoCorrect = "off";
    if (filled)
        variant = "filled";
    if (outlined)
        variant = "outlined";
    if (solo)
        variant = "solo";
    if (borderless)
        variant = "borderless";
    if (small)
        size = "small";
    if (normal)
        size = "normal";
    if (large)
        size = "large";
    if (prefix)
        textLeft = prefix;
    if (suffix)
        textRight = suffix;
    if (numeric && typeof selectAllOnFocus === 'undefined')
        selectAllOnFocus = true;
    React.useEffect(function () {
        var _a, _b;
        if (autoFocus) {
            (_a = inputEl.current) === null || _a === void 0 ? void 0 : _a.focus();
            if (selectAllOnFocus)
                (_b = inputEl.current) === null || _b === void 0 ? void 0 : _b.select();
        }
    }, []);
    React.useEffect(function () {
        var _a, _b;
        if (inputEl.current && inputCharPos >= 0 && ((_a = inputEl.current) === null || _a === void 0 ? void 0 : _a.selectionStart) !== inputCharPos) {
            if (((_b = inputEl.current) === null || _b === void 0 ? void 0 : _b.type) !== 'number') {
                //inputEl.current?.selectionStart = inputCharPos;
                //inputEl.current?.selectionEnd = inputCharPos;
            }
        }
        if (!isFocused) {
            if (typeof round === 'number') {
                if (typeof value !== 'undefined' && parseFloat(value).round(round) !== parseFloat(inputValue).round(round)) {
                    setInputValue(parseFloat(value).round(round).toString());
                }
                else if (value !== inputValue) {
                    setInputValue(parseFloat(value || '').round(round).toString());
                }
            }
            else {
                if (value !== inputValue) {
                    if (numeric) {
                        setInputValue(value && !Number(value).isNan() ? value.toString() : '');
                    }
                    else if (value !== inputValue) {
                        setInputValue(value ? value.toString() : '');
                    }
                }
            }
        }
        if (!isClearableVisible && clearable && inputValue && !readOnly || disabled) {
            setIsClearableVisible(true);
        }
        else if (isClearableVisible && (!inputValue || (readOnly || disabled))) {
            setIsClearableVisible(false);
        }
        if (mask) {
            formatedMaskTests.push.apply(formatedMaskTests, setupRegex(mask));
        }
        if (ref) {
            if (typeof ref === "function") {
                ref(inputEl.current);
            }
            else {
                ref.current = inputEl.current;
            }
        }
    });
    var changePasswordVisibility = function (target) {
        setPasswordVisible(!isPasswordVisible);
    };
    var selfKeyDown = function (event) {
        if (event.key === 'ArrowUp')
            event.preventDefault();
        else if (event.key === 'ArrowDown')
            event.preventDefault();
        if (typeof onKeyDown === 'function')
            onKeyDown(event);
        if (event.key === 'Enter' && typeof onEnterDown === 'function')
            onEnterDown(event);
        else if (event.key === 'Escape' && typeof onEscapeDown === 'function')
            onEscapeDown(event);
    };
    var selfKeyUp = function (event) {
        if (event.key === 'Enter' && typeof onEnterUp === 'function') {
            inputOnChange(event, true);
            onEnterUp(event);
        }
        else if (event.key === 'Escape' && typeof onEscapeUp === 'function') {
            inputOnChange(event, true);
            onEscapeUp(event);
        }
        else {
            if (waitEmit.current) {
                clearTimeout(waitEmit.current);
            }
            waitEmit.current = setTimeout(function () { inputOnChange(event, true); }, 300);
        }
        if (typeof onKeyUp === 'function')
            onKeyUp(event);
    };
    var inputOnChange = function (event, forceEmit) {
        if (forceEmit === void 0) { forceEmit = false; }
        if (emitAll)
            forceEmit = true;
        if (typeof event.target.value !== 'string')
            event.target.value = inputValue;
        if (typeof mask === 'string') {
            var value_1 = event.target.value;
            if (typeof value_1 === 'string' && value_1.length > 0) {
                if ((inputValue && inputValue.length > 0) && inputValue.length > value_1.length) {
                    Wait(1500).then(function () {
                        var _a;
                        if (inputEl.current && ((_a = inputEl.current) === null || _a === void 0 ? void 0 : _a.value) === value_1) {
                            if (typeof beforeCheckMask === 'function')
                                value_1 = beforeCheckMask(value_1, { isDel: true });
                            var _b = testRegex(value_1, formatedMaskTests), text = _b.text, charsPassed = _b.charsPassed;
                            inputEl.current.selectionStart += charsPassed;
                            event.target.value = text;
                            //event.target.valueAsNumber = Number.isNaN( parseFloat( text ) ) ? 0 : parseFloat( text );
                        }
                    });
                }
                else {
                    if (typeof beforeCheckMask === 'function')
                        value_1 = beforeCheckMask(value_1, {});
                    var _a = testRegex(value_1, formatedMaskTests), text = _a.text, charsPassed = _a.charsPassed;
                    //inputEl.current?.selectionStart += charsPassed;
                    event.target.value = text;
                }
            }
            //if ( inputEl.current?.selectionStart !== inputCharPos )
            //  setInputCharPos( inputEl.current?.selectionStart );
            setInputValue(event.target.value);
            forceEmit && emit(event);
        }
        else {
            //if ( inputEl.current?.selectionStart !== inputCharPos )
            //          setInputCharPos( inputEl.current?.selectionStart );
            setInputValue(event.target.value);
            forceEmit && emit(event);
        }
    };
    var emit = function (event) {
        if (numeric) {
            if (String(event.target.value).endsWith('.') || String(event.target.value).endsWith(','))
                event.target.value = String(event.target.value).delete('.').delete(',');
            event.target.value = Number.isNaN(parseFloat(event.target.value)) ? 0 : parseFloat(event.target.value);
        }
        onChange && onChange(event);
    };
    var clear = function () {
        setInputValue('');
        emit({ target: { value: numeric ? 0 : '' } });
        onClear && onClear();
    };
    var selfFocus = function (event) {
        var _a;
        toogleOptions('open');
        if (selectAllOnFocus) {
            (_a = inputEl.current) === null || _a === void 0 ? void 0 : _a.select();
        }
        if (typeof onFocus === 'function')
            onFocus(event);
        setFocus(true);
        if (isErrored)
            setTimeout(function () {
                setErrored(false);
            }, 300);
    };
    var selfBlur = function (event) {
        if (typeof mask === 'string' && event.target.value && formatedMaskTests && formatedMaskTests.length !== event.target.value.length) {
            if (typeof beforeCheckMask === 'function')
                event.target.value = beforeCheckMask(event.target.value, { isBlur: true });
            var _a = testRegex(event.target.value, formatedMaskTests, true), text = _a.text, charsPassed = _a.charsPassed;
            event.target.value = text;
            inputOnChange(event);
        }
        inputOnChange(event, true);
        if (typeof onBlur === 'function')
            onBlur(event);
        var value = event.target.value;
        setFocus(false);
        if (isErrored && !required && !value) {
            setErrored(false);
        }
        else if (!isErrored && required && !value) {
            if (typeof onValidateError === "function")
                onValidateError(event.target);
            setErrored(true);
        }
        else if (typeof validator === "function") {
            var errored = !validator(value);
            if (isErrored != errored) {
                if (errored && typeof onValidateError === "function")
                    onValidateError(event.target);
                setErrored(errored);
            }
        }
        toogleOptions('close');
    };
    var handleClickAway = function () {
        if (contentModal)
            setTimeout(function () { toogleOptions('close'); }, 150);
    };
    var toogleOptions = function (openOrClose) {
        if (contentModal && !readOnly && !disabled) {
            setOptionsOpen(openOrClose === 'open');
        }
    };
    var inputType = "text";
    if (password && !isPasswordVisible)
        inputType = "password";
    //if ( numeric ) inputType = "number";
    var classes = classNames((_b = {
            '__input': true,
            'focused': isFocused,
            '[styles.errored]': isErrored
        },
        _b[color] = !!color,
        _b["size__".concat(size || "normal")] = true,
        _b["variant__".concat(variant || "outlined")] = true,
        _b));
    var fieldClasses = classNames({
        'focused': isFocused,
        'errored': isErrored,
    });
    var iconRightClasses = classNames({
        'clickeable__icon': typeof onClickIconRight === "function",
    });
    var iconLeftClasses = classNames({
        'clickeable__icon': typeof onClickIconLeft === "function",
    });
    var hintsClasses = classNames({
        'hint__wrapper': errorMessage || hint,
    });
    var modalClasses = classNames((_c = {},
        _c["size__".concat(size || "normal")] = true,
        _c["variant__".concat(variant || "outlined")] = true,
        _c));
    return (_jsx(_Fragment, { children: _jsx(ClickAwayListener, __assign({ onClickAway: handleClickAway }, { children: _jsxs("div", __assign({ className: "".concat(rootClassname || ""), style: { position: 'relative', width: '100%' } }, { children: [_jsxs("div", __assign({ ref: rootEl, style: { width: width || undefined }, className: "".concat(classes, " ").concat(rootClassname || ""), onClick: function () { return inputEl.current.focus(); } }, { children: [label && (_jsx("div", __assign({ className: "label" }, { children: _jsxs("label", __assign({ htmlFor: (_d = inputEl === null || inputEl === void 0 ? void 0 : inputEl.current) === null || _d === void 0 ? void 0 : _d.id }, { children: [label, " "] })) }))), _jsx("div", __assign({ className: "wrapper" }, { children: _jsxs("div", __assign({ className: "field ".concat(fieldClasses) }, { children: [iconLeft && (_jsxs("div", __assign({ onClick: function (event) {
                                                onClickIconLeft && onClickIconLeft(event);
                                            }, className: "content__icon__left ".concat(iconLeftClasses || "") }, { children: [typeof iconLeft === 'string' && _jsx("i", { className: "pi pi-".concat(iconLeft) }), typeof iconLeft !== 'string' && iconLeft] }))), contentLeft && contentLeft, textLeft && (_jsx("div", __assign({ className: "content__text__left" }, { children: _jsx("span", { children: textLeft }) }))), _jsx("input", __assign({ type: inputType, pattern: numeric ? "\d+((\.|,)\d+)?"
                                                : onlyNumbers ? "\d+?"
                                                    : undefined, ref: inputEl, disabled: disabled, readOnly: readOnly }, props, { placeholder: typeof props.placeholder === 'string' ? props.placeholder : undefined, className: "".concat(className || "", " input"), onFocus: function (e) { return selfFocus(e); }, onBlur: function (e) { return selfBlur(e); }, onKeyDown: function (e) { return selfKeyDown(e); }, onKeyUp: function (e) { return selfKeyUp(e); }, value: numeric && (!inputValue || inputValue == '0') ? '' : inputValue, onChange: function (e) { return inputOnChange(e); } })), textRight && (_jsx("div", __assign({ className: "content__text__right" }, { children: _jsx("span", { children: textRight }) }))), contentRight && contentRight, iconRight && (_jsxs("div", __assign({ onClick: function (event) {
                                                onClickIconRight && onClickIconRight(event);
                                            }, className: "".concat("content__icon__right", " ").concat(iconRightClasses || "") }, { children: [typeof iconRight === 'string' && _jsx("i", { className: "pi pi-".concat(iconRight) }), typeof iconRight !== 'string' && iconRight] }))), isClearableVisible && !readOnly && !disabled && (_jsx("div", __assign({ onClick: function (event) { clear(); }, className: "".concat("content__icon__right", " ").concat("clickeable__icon") }, { children: _jsx("i", { className: "pi pi-times t-x-small" }) }))), password && (_jsx("div", __assign({ onClick: function (event) {
                                                changePasswordVisibility(event);
                                            }, className: "".concat("content__icon__right", " ").concat("clickeable__icon") }, { children: _jsx("i", { className: "pi pi-".concat(!isPasswordVisible ? "eye" : "eye-slash") }) })))] })) })), _jsxs("div", __assign({ className: hintsClasses }, { children: [isErrored && errorMessage && (_jsx("div", __assign({ className: "error__label" }, { children: _jsx("span", { children: errorMessage }) }))), !(isErrored && errorMessage) && hint && (_jsx("div", __assign({ className: "hint__label" }, { children: _jsx("span", { children: hint }) })))] }))] })), contentModal && optionsOpen && (_jsx("div", __assign({ className: "".concat(modalClasses, " ").concat("listbox"), style: {
                            top: rootEl.current ? rootEl.current.clientHeight : 0,
                            width: widthModal ? widthModal : (rootEl.current ? (_e = rootEl.current) === null || _e === void 0 ? void 0 : _e.clientWidth : 0),
                            visibility: optionsOpen ? 'visible' : 'collapse'
                        } }, { children: contentModal })))] })) })) }));
});
